// D80-a/j — "built to try": what this app does not do yet, in the creator's own words, and no claim that it is ready.
// The list is the request contract's own (mandatory requirements UNMET or UNVERIFIED), never a summary written for the screen.
import type { JSX } from 'preact';
import { Ic, tt } from '../v2/icons';
import { t } from '../lib/i18n';
import type { DeliveryRecord } from '../lib/creator-apps-api';

export function DeliveryNotice({ delivery, shareUrl, onTry }: { delivery: DeliveryRecord; shareUrl: string; onTry: () => void }): JSX.Element {
  return (
    <div className="panel" data-delivery-state="built_to_try">
      <div className="panel-hd">
        <span className="l-ico warn"><Ic n="spark" /></span>
        <h3>{t('dlv.title')}</h3>
      </div>
      <div className="panel-p stack" style="gap:12px">
        <p className="sub-h" style="margin:0">
          {tt('dlv.sub', 'This app does not do everything you asked yet, so it is not offered as ready. Try it, and tell the editor what to add.')}
          {' '}
          {delivery.mandatoryMet}/{delivery.mandatoryTotal}
        </p>
        <ul data-delivery-unmet style="margin:0;padding-inline-start:18px">
          {delivery.unmet.map((r) => (
            <li key={r.id} data-requirement-status={r.status}>
              {r.text}
              <span className="sub-h"> — {r.status === 'UNMET' ? t('dlv.unmet') : t('dlv.unverified')}</span>
            </li>
          ))}
        </ul>
        {shareUrl ? (
          <button className="btn btn-primary" type="button" onClick={onTry}>
            <Ic n="ext" /> {t('dlv.try')}
          </button>
        ) : null}
      </div>
    </div>
  );
}
